enum Pages {
    Home = "",
}

export default Pages;